export default __webpack_public_path__ + "static/media/icon_new_file.842d8d0a.svg";